var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "209.000000pt",
    height: "208.000000pt",
    viewBox: "0 0 209.000000 208.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,208.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885 1996 c-5 -3 -22 -7 -37 -10 -37 -8 -98 -63 -114 -103 -8 -18 -14 -62 -14 -98 l0 -65 -171 0 c-157 0 -175 -2 -206 -21 -43 -27 -63 -66 -63 -124 0 -60 25 -112 64 -136 30 -18 63 -19 715 -19 668 0 684 0 716 20 86 53 86 207 0 260 -29 18 -49 20 -204 20 l-171 0 0 64 c0 76 -11 110 -48 149 -54 57 -71 61 -272 64 -102 1 -189 1 -195 -1z m394 -90 c36 -19 51 -55 51 -126 l0 -60 -270 0 -270 0 0 61 c0 65 10 94 44 121 18 15 47 18 219 18 152 0 204 -3 226 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 1302 c0 -16 23 -269 50 -562 57 -601 55 -592 139 -637 44 -23 44 -23 459 -23 402 0 417 1 459 21 29 14 52 35 68 62 22 39 27 76 75 579 27 295 50 548 50 562 l0 26 -165 0 c-91 0 -165 -1 -166 -2 0 -2 -11 -202 -23 -446 -19 -365 -26 -446 -38 -459 -19 -18 -55 -10 -62 15 -3 9 5 214 17 455 l22 437 -97 0 -98 0 0 -449 c0 -390 -2 -450 -15 -461 -12 -10 -21 -10 -40 -2 l-25 12 0 450 0 450 -98 0 -98 0 3 -62 c23 -415 41 -823 36 -834 -8 -21 -43 -28 -61 -11 -12 13 -19 96 -38 459 -12 244 -23 444 -23 446 -1 1 -75 2 -166 2 l-165 0 0 -28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.a25cbe07bbed10d27baac6d8eb1aec06.svg";
export { ForwardRef as ReactComponent };